const BLIP_SOUND_URL =
    'https://pom-safe-app-storage.s3.amazonaws.com/aware-sounds/blip.wav';
const RING_SOUND_URL =
    'https://pom-safe-app-storage.s3.amazonaws.com/aware-sounds/ring.wav';
const WARNING_BEEP_URL =
    'https://pom-safe-app-storage.s3.amazonaws.com/aware-sounds/beep-warning-6387.mp3';

export const NO_SOUND = '__'

// ALERT_URLS contains the names and urls of the sounds that users can choose for alerts
export const ALERT_URLS = [
    { soundUrl: BLIP_SOUND_URL, name: 'Blip' },
    { soundUrl: RING_SOUND_URL, name: 'Ring' },
    { soundUrl: WARNING_BEEP_URL, name: 'Warning' },
    { soundUrl: NO_SOUND, name: 'No Sound'}
] as NamedURLtype [];

// NamedURLtype is the type of a sound object
export type NamedURLtype = {
    name: string; // name is the name of the sound
    soundUrl: string; // soundUrl is the url to the sound
};
